import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DeleteUserDialogComponent } from '../../../entities/profile/delete-user-dialog/delete-user-dialog.component';

@Component({
  selector: 'app-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})
export class DeleteConfirmDialogComponent implements OnInit {
  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();
  small = false;
  victory = false;
  title = '';
  element: string;
  message: string;
  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.victory = data.victory;
    this.small = data.small;
    this.element = data.element;
    this.message = data.message;
    this.title = data.title;
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    document.getElementById('unfocus').classList.add('unfocus');
  }

  onCloseDialog() {
    document.getElementById('unfocus').classList.remove('unfocus');
    this.dialogRef.close();
  }

  delete() {
    this.action.emit(true);
    this.onCloseDialog();
  }

  cancel() {
    this.action.emit(false);
    this.onCloseDialog();
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/delete-confirm-dialog/delete-confirm-dialog.component.ts